module.exports = __webpack_public_path__ + "static/media/EXTC_Video2026.2d15db67.mp4";